var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHands(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M48.5288 63.8618L45.4261 55.9161C45.0587 54.9753 43.993 54.5004 43.0428 54.8715C42.102 55.2388 41.6272 56.3046 41.9982 57.2547L47.4215 71.1434C48.4364 73.7423 51.3673 75.0347 53.9755 74.0162L60.8409 71.5286L60.9992 71.4668C63.3746 70.5392 65.0175 68.341 65.2092 65.8078C65.313 64.479 65.2945 63.1121 65.2731 61.8752C65.2496 59.0932 65.3867 58.2345 65.5551 56.494C65.7272 54.7628 65.3422 54.1617 64.3796 53.7861C63.4171 53.4105 62.6136 54.2395 61.9044 55.1176C61.1952 55.9957 61.1942 58.6048 61.0571 59.4635C61.0002 59.84 60.8317 60.4533 60.6617 61.035C60.522 61.5297 59.8236 61.5555 59.6381 61.0804L55.2186 49.7627C54.8331 48.7753 53.7155 48.2777 52.7188 48.6669C51.7314 49.0525 51.2338 50.17 51.623 51.1667L54.9331 59.6434",
    stroke: "#EF9071",
    strokeWidth: 1.0744,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M48.5288 63.8621L44.1712 52.7027C43.8039 51.7619 44.2658 50.6905 45.2159 50.3195C46.1567 49.9521 47.2281 50.414 47.5992 51.3642L51.4912 61.3312",
    stroke: "#EF9071",
    strokeWidth: 1.0744,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M51.4879 61.3216L46.9266 49.6406C46.5411 48.6532 47.0257 47.53 48.0224 47.1408C49.0098 46.7552 50.133 47.2398 50.5222 48.2365L54.9671 59.6195",
    stroke: "#EF9071",
    strokeWidth: 1.0744,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M61.3696 30.764L56.0685 37.4503C55.4343 38.2454 55.5752 39.4035 56.3667 40.0284C57.1619 40.6626 58.32 40.5217 58.9449 39.7302L68.2109 28.0497C69.943 25.8596 69.5828 22.683 67.3928 20.951L61.786 16.2697L61.6476 16.1627C59.655 14.579 56.9223 14.2613 54.6326 15.3808C53.4358 15.9448 52.2749 16.6557 51.2112 17.2858C48.8262 18.7109 48.0029 19.0217 46.4184 19.7478C44.834 20.4738 44.5149 21.1137 44.6737 22.1253C44.8325 23.1368 45.9555 23.4283 47.072 23.5935C48.1793 23.7623 50.437 22.4512 51.2568 22.1311C51.6107 21.9929 52.223 21.829 52.8204 21.6816C53.3209 21.5613 53.6857 22.1381 53.3704 22.5404L45.8157 32.0604C45.1552 32.8981 45.2956 34.11 46.1296 34.7612C46.9673 35.4218 48.1792 35.2814 48.8305 34.4473L54.4825 27.3128",
    stroke: "#EF9071",
    strokeWidth: 1.0744,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M61.3695 30.7642L53.9218 40.1459C53.2876 40.9411 52.1352 41.069 51.3437 40.4441C50.5485 39.8099 50.4206 38.6575 51.0455 37.866L57.692 29.4842",
    stroke: "#EF9071",
    strokeWidth: 1.0744,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M57.7014 29.4803L49.9121 39.3067C49.2515 40.1443 48.0396 40.2848 47.2112 39.6206C46.3736 38.96 46.2331 37.7481 46.8973 36.9198L54.4933 27.3406",
    stroke: "#EF9071",
    strokeWidth: 1.0744,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M26.8235 44.0175L35.8305 45.3098C36.8859 45.4559 37.6132 46.4387 37.4671 47.4941C37.321 48.5495 36.3383 49.2768 35.2828 49.1307L23.2487 47.3994C22.7386 47.3302 22.4272 47.9349 22.7788 48.3129C23.2061 48.7473 23.6629 49.2023 23.9563 49.4312C24.6389 49.9698 26.9143 51.2606 27.3253 52.3132C27.7327 53.3565 28.0615 54.4734 27.2614 55.1186C26.4613 55.7638 25.7515 55.8156 24.3298 54.8141C22.9081 53.8126 22.2218 53.2647 19.7854 51.9188C18.7039 51.3212 17.5059 50.6725 16.3979 49.9243C14.287 48.5049 13.1879 45.9926 13.5447 43.47L13.5647 43.3012L14.7772 36.0966C15.1787 33.3311 17.7349 31.4097 20.5005 31.8113L35.2519 33.9308C36.2535 34.0765 36.9496 35.007 36.804 36.0086C36.6583 37.0102 35.7278 37.7063 34.7262 37.5607L26.2867 36.3473",
    stroke: "#EF9071",
    strokeWidth: 1.0744,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M26.3151 36.3367L38.1674 38.0424C39.169 38.188 39.8652 39.1186 39.7195 40.1201C39.5739 41.1217 38.6433 41.8179 37.6418 41.6722L27.0526 40.1496",
    stroke: "#EF9071",
    strokeWidth: 1.0744,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M27.0559 40.1588L39.4758 41.9434C40.5312 42.0895 41.2585 43.0723 41.1124 44.1277C40.9663 45.1832 39.9836 45.9105 38.9281 45.7644L26.8272 44.0269",
    stroke: "#EF9071",
    strokeWidth: 1.0744,
    strokeMiterlimit: 10
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHands);
export default __webpack_public_path__ + "static/media/hands.bd4accd99122f45f04ced6febeb2998f.svg";
export { ForwardRef as ReactComponent };